export default __webpack_public_path__ + "static/media/UFT2.ee6039d9.jpg";